// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"8b02fcf8","420":"43e1d26f","508":"769795f7","662":"978e61b0","666":"c25a2132","720":"3ec54acc","833":"9d5b18d3","860":"1d776931","940":"741e406c"}[chunkId] + ".chunk.js";
};